import React, { useState, useEffect } from 'react';
import { useGetEarnings } from '../../api/Earnings/getEarnings';
import { AdminLayout } from '@/components/Layout';
import { Button, Table } from '@/components/Elements';
import TableLoader from '@/components/Elements/Loader/TableLoader';
import BackdropLoader from '@/components/Elements/Loader/BackdropLoader';
import { User } from '@/types';
import i18next from 'i18next';
import { usePagination } from '@/hooks/usePagination';

const Earnings = () => {
  const [flag, setFlag] = useState('customer_subscription');
  const [search, setSearch] = useState('');
  const options = [
    'customer_subscription',
    'agency_subscription',
    'lawyer_subscription',
    'do_it_reeipo',
  ];
  const { page, changePage } = usePagination();
  const { data, isLoading, isFetching, refetch } = useGetEarnings(flag, page, search);

  // Refetch the data whenever flag or search changes
  useEffect(() => {
    refetch();
  }, [page, flag, search, refetch]);

  return (
    <AdminLayout title="Earnings">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <select className="select-dropdown" onChange={(e) => setFlag(e.target.value)} value={flag}>
          {options.map((option, index) => (
            <option key={index} value={option}>
              {option.split('_').join(' ')}
            </option>
          ))}
        </select>
        <div style={{ minWidth: 300 }} className="ms-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search by email or name..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ float: 'right' }}
          />
        </div>
      </div>
      {/* <BackdropLoader open={isLoading || isFetching} /> */}
      {isLoading || isFetching ? (
        <TableLoader />
      ) : (
        <Table<User>
          page={parseInt(page)}
          changePage={changePage}
          total={data?.count ?? 0}
          data={data?.data ?? []}
          columns={[
            { title: `${i18next.t('Customer Name')}`, field: 'customer_name' },
            { title: `${i18next.t('Email')}`, field: 'email' },
            {
              title: `${i18next.t('Plan')}`,
              field: 'plan',
              Cell({ entry: { plan } }) {
                let planText;
                if (plan === 'Silver') {
                  planText = 'Base';
                } else if (plan === 'Gold') {
                  planText = 'Standard';
                } else if (plan === 'Diamond') {
                  planText = 'Premium';
                } else {
                  planText = 'N/A';
                }
                return <span>{planText}</span>;
              },
            },
            {
              title: `${i18next.t('Status')}`,
              field: 'is_active',
              Cell({ entry: { is_active } }) {
                return <span>{is_active ? 'Active' : 'Inactive'}</span>;
              },
            },
          ]}
        />
      )}
    </AdminLayout>
  );
};

export default Earnings;
